import { Outlet, useOutletContext } from 'react-router-dom'

const EmployeeSoftwarePage = () => {
  return <Outlet context={useOutletContext()} />
}

export default EmployeeSoftwarePage
